import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";

import {useCustomFields} from "../../../../contexts/customFields";
import {useShopping} from "../../../../contexts/shopping";
import Input from "../../../../components/form/Input";
import CartItemFields from "../CartItemFields";
import CartItemsHeader from "../CartItemsHeader";

export default function Items({ disabled, list }) {
  const { inventoryAssets } = useShopping();

  const allItems = list.flatMap(([_, items]) => items);
  const hasSkuNumber = allItems.some(
    item => inventoryAssets[item.assetId]?.skuNumber
  );
  const hasBarcode = allItems.some(item => inventoryAssets[item.assetId]?.barcode);
  const hasModel = allItems.some(item => inventoryAssets[item.assetId]?.model);
  const hasDimensions = allItems.some(
    item =>
      inventoryAssets[item.assetId]?.dimensions &&
      inventoryAssets[item.assetId]?.dimensions.length > 0
  );

  const display = {
    ii_image: true,
    ii_item_id: true,
    ii_description: true,
    ii_qtyRequested: true,
    ii_location: true,
    ii_sku_number: hasSkuNumber,
    ii_barcode: hasBarcode,
    ii_model: hasModel,
    ii_dimensions: hasDimensions,
    sc_price: true,
  };

  return list.map(([value, list], index) => (
    <Box mt={index === 0 ? 0 : 3} borderRadius={3} p={2} border="1px solid #3f51b5">
      <Input
        disabled={disabled}
        type="text"
        name={`locationNotes[${value.split(",")[0]}]`}
        label={`${value.split(",")[0]} Scope`}
      />
      <Box mt={2} />
      <Paper>
        <Table>
          <CartItemsHeader display={display} />
          <TableBody>
            {list.map(item => {
              const asset = inventoryAssets[item.assetId];
              return (
                <CartItemFields
                  key={item.id}
                  disabledQty
                  disabledAddress
                  disabled={disabled}
                  display={display}
                  asset={asset}
                  inventoryItem={item}
                />
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  ));
}
